<template>
  <CConfirmationModal
    v-model:model-value="modelValue"
    :cancel-text="t('canvasUI.browserApp.bulkAddToSharebox.warningModal.cancel')"
    :confirm-text="t('canvasUI.browserApp.bulkAddToSharebox.warningModal.continue')"
    @confirm="emit('confirm')"
  >
    <template #header>
      <div class="font-semibold text-xl c-confirmation-modal__title">
        {{ t('canvasUI.browserApp.bulkAddToSharebox.warningModal.title') }}
      </div>
    </template>
    <div class="flex flex-col">
      <p class="mb-6">
        {{ t('canvasUI.browserApp.bulkAddToSharebox.warningModal.content', { count: unshareableFiles.length }) }}
      </p>
      <p class="mb-4">
        {{ t('canvasUI.browserApp.bulkAddToSharebox.warningModal.theseFilesWontBeAdded') }}
      </p>
      <div class="flex flex-col gap-1 overflow-y-auto max-h-60">
        <div
          v-for="file in unshareableFiles"
          :key="file.id"
          class="flex items-center gap-2 cursor-pointer font-semibold"
          :style="{ color: themeVars.text }"
          @click="emit('open-file', file.id)"
        >
          <span class="hover:underline">{{ file.name ?? '-' }}</span>
          <CIcon icon="arrow-up-right-from-square" size="16px" />
        </div>
      </div>
    </div>
  </CConfirmationModal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import CConfirmationModal from '@lib/components/CConfirmationModal/CConfirmationModal.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import useThemeVars from '@lib/composables/useThemeVars'
import type { ViewCompactFile } from '@lib/types/files'

interface Props {
  show: boolean
  unshareableFiles: ViewCompactFile[]
}

const props = defineProps<Props>()

const emit = defineEmits<{
  'update:show': [value: boolean]
  'open-file': [fileId: string]
  confirm: []
}>()

const { t } = useI18n()
const themeVars = useThemeVars()

const modelValue = computed({
  get: () => props.show,
  set: (value) => emit('update:show', value),
})
</script>
